<div class="content-list">
  <dcu-box-data>
    <div title class="header-custom">
      <dcu-body-header *ngIf="chartContent.header" [headerTitle]="chartContent.header?.title" [subTitle]="chartContent.header?.subTitle"></dcu-body-header>

      <div class="status-select"></div>

      <div class="btn-group btn-group-toggle float-right" *ngIf="chartContent.searchArea">
        <i class="fa fa-filter" aria-hidden="true" *ngIf="chartContent.searchArea?.filter" (click)="toggleFilter()" id="{{id}}-filter-icon"></i>
        <button type="button" class="close" (click)="addNewCustom()" *ngIf="chartContent.closeDialog">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>

    <dcu-body-filter
      [hidden]="!showFilter"
      [filterData]="chartContent.filterConfig"
      (onChangeSearch)="onChangeFilter($event)"
      (onChangeForm)="onChangeDataFilter($event)"
      (keyup.enter)="onChangeFilter($event)"
      [idFilter]="id"
      [classCustom]="chartContent.classCustom"
      (clearValue)="onClearValue($event)"
      [isCustomCancelFilter]="isCustomCancelFilter"
    ></dcu-body-filter>

    <ng-content select="[retrieve]"></ng-content>

    <div class="mt-3">
      <canvas *ngIf="!isLoading" baseChart
      [datasets]="chartDatas"
      [labels]="chartLabels"
      [options]="chartOptions"
      [colors]="chartColors"
      [legend]="chartLegend"
      [chartType]="chartType"
      [plugins]="chartPlugins">
    </canvas>
    </div>
  </dcu-box-data>
</div>

